import { useCallback, useState } from 'react';
import type { LayoutChangeEvent } from 'react-native';

import type { CarouselLayoutSize } from '@/shared/types/carousel';

/**
 * Measures the carousel's own container. The app is already constrained to a
 * max width and centered by the root container (see App.tsx), so the layout
 * width returned by onLayout is the correct available width — no need to read
 * the browser window and clamp it manually.
 */
export const useCarouselLayout = () => {
  const [layout, setLayout] = useState<CarouselLayoutSize>({
    width: 0,
    height: 0
  });

  const onLayout = useCallback((e: LayoutChangeEvent) => {
    const { width, height } = e.nativeEvent.layout;
    setLayout((prev) => {
      if (prev?.width === width && prev?.height === height) return prev;
      return { width, height };
    });
  }, []);

  return { layout, onLayout };
};
